import { __rest } from 'tslib';
import React from 'react';
import { s as styled } from './styled-112a8bd0.js';

const Wrapper = styled.div `
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 29px;
  height: 30px;
  border-radius: 999px;
  width: fit-content;
  text-align: center;
  background: #f6f6f6;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  outline: 0;
  white-space: nowrap;
  border: none;
  padding: 0 12px;
  cursor: pointer;
`;
const Chip = (_a) => {
    var { onClick, children } = _a, props = __rest(_a, ["onClick", "children"]);
    return (React.createElement(Wrapper, Object.assign({}, props, { onClick: onClick }), children));
};

export { Chip as C };
